import * as React from "react";
const SvgDocumentText = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M39 42h6m-6 4h6m2 5H37a2 2 0 0 1-2-2V35a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V49a2 2 0 0 1-2 2"
    />
  </svg>
);
export default SvgDocumentText;
